module.exports = __webpack_public_path__ + "static/media/image-1.e9ca011f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Neighborhood/image-1.png
// module id = 262
// module chunks = 0